import React from 'react';

export const AddIcon = () => {
  return <div data-testid="add-icon-id" className="vbz-icon-corporates-club-add-icon" />;
};
